import React from 'react';
export function Hook() {
  return <section aria-labelledby="gancho-titulo" className="w-full border-t border-line bg-ink py-20 sm:py-28" data-id="element-77" data-mp="3vc9d4p5tbcx">
      <div className="mx-auto max-w-read px-4" data-id="element-78" data-mp="2b7mzoc8gubk7">
        <h2 id="gancho-titulo" className="font-display text-3xl font-bold uppercase leading-tight tracking-tight text-bone sm:text-4xl" data-id="element-79" data-mp="1x72cz4zfjvlf">
          ¿Alguna vez sentiste que tus piernas simplemente «se apagan» en el kilómetro 15?
        </h2>
        <p className="mt-6 text-lg leading-relaxed text-mute" data-id="element-80" data-mp="2p02wuweorfd7">
          ¿Esa frustración de ver cómo otros te pasan en las subidas mientras vos luchás por recuperar el aliento?
        </p>
        <p className="mt-10 font-display text-2xl font-bold uppercase leading-tight text-bone sm:text-3xl" data-id="element-81" data-mp="2g3byuegkpqfz">
          No es falta de voluntad.
        </p>
        <p className="mt-4 text-lg leading-relaxed text-mute" data-id="element-82" data-mp="37vjh1jbq9awh">
          Es que estás usando <span className="text-bone" data-id="element-83" data-mp="3cnkq6wdlmlia">un plan de calle en un mundo de montañas</span>. Y si no cambiás el enfoque, solo estás a una piedra de una lesión crónica.
        </p>
      </div>
    </section>;
}